<template>
    <div class="app">
        <h1>{{newDetail.title}}</h1>
        <h3 style="margin:40px 0;text-indent:2em;">{{newDetail.abstract}}</h3>
        <div class="info">
            <div>发布时间：{{newDetail.publishtime|setTime}}</div>
            <div style="margin-left: 12px;">作者：{{newDetail.author}}</div>
            <div style="margin-left: 12px;">点击量{{newDetail.click}}</div>
        </div>
        <img :src="newDetail.img" width="100%" alt="">
        <div style="margin:0 auto;margin-bottom:130px;" v-html="newDetail.content"></div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: "newsList",
        filters:{
            setTime(time) {
                let now = new Date(1000 * time);
                var year = now.getFullYear();
                var month = now.getMonth() + 1;
                if (month < 10) {
                  month = "0" + month;
                }
                var date = now.getDate();
                if (date < 10) {
                  date = "0" + date;
                }
                return year + "-" + month + "-" + date
            },
        },
        mounted(){
            console.log(this.$route.query.cid);
            axios({
                url:'/web.php/news/news_content?cid='+this.$route.query.cid,
                
            }).then(res=>{
              if(res.data.msg == "ok"){
                this.newDetail = res.data.data
              }
            })
        },
        data(){
            return {
                newDetail:{}
            }
        }
    }

</script>

<style scoped>
    .app {
        width: 50%;
        margin: 0 auto;
        position: relative;
        top: 50px;
    }
    .info {
        font-size: 12px;
        color: #c1c1c1;
        display: flex;
        margin: 20px 0;

    }

    
</style>